var exports = {
  "YD": "xaee3c4fa--b5b477--empty-wrapper",
};

module.exports = exports;
